import React, { useState, useEffect } from "react";
import "./TopNav.css";

import { BiSolidUser, BiBell } from "react-icons/bi";
import { IoMdArrowDropdown } from "react-icons/io";
import {
  Box,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";

import Logout from "@mui/icons-material/Logout";
import api from "../../../../configs/api";

import Cookies from "js-cookie";
import { useLocation, useNavigate } from "react-router";

const TopNav = () => {
  const [adminName, setAdminName] = useState("");

  const location = useLocation();

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogOut = () => {
    Cookies.remove("token");
    navigate("/admin");
  };

  useEffect(() => {
    async function getAdminName() {
      try {
        const res = await api.get("admin/get_admin");
        setAdminName(res.data.fullName);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
    getAdminName();
  }, []);

  return (
    <div
      className={`main__top h-[120px] bg-[#4a3c57] sm:flex sm:justify-between justify-center flex sm:flex-row flex-col sm:items-start items-center`}
    >
      <div
        className={`${
          location.pathname === "/admin/home" ? "" : "hidden md:block"
        }`}
      >
        <h1 className={`h_name`}>
          Welcome back,<span className='span_name'> {adminName}</span>
        </h1>
        <p className='top_p'>Administrator's Dashboard</p>
      </div>
      <div className='flex flex-row top__icon md:mt-12 md:mr-20 mt-0 justify-center items-center'>
        {/* <BiBell className='icon_user mr-8 text-primary' /> */}
        <div className='line'></div>
        <div className=''>
          <Box sx={{}}>
            <Tooltip title='Account settings'>
              <IconButton
                onClick={handleClick}
                size='small'
                sx={{ ml: 2 }}
                aria-controls={open ? "account-menu" : undefined}
                aria-haspopup='true'
                aria-expanded={open ? "true" : undefined}
              >
                <BiSolidUser className='icon_user' />
              </IconButton>
            </Tooltip>
          </Box>
          <Menu
            anchorEl={anchorEl}
            id='account-menu'
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
              elevation: 0,
              sx: {
                overflow: "visible",
                filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                mt: 1.5,
                "& .MuiAvatar-root": {
                  width: 32,
                  height: 32,
                  ml: -0.5,
                  mr: 1,
                },
                "&:before": {
                  content: '""',
                  display: "block",
                  position: "absolute",
                  top: 0,
                  right: 14,
                  width: 10,
                  height: 10,
                  bgcolor: "background.paper",
                  transform: "translateY(-50%) rotate(45deg)",
                  zIndex: 0,
                },
              },
            }}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            {/* <MenuItem onClick={ () => handleEdit(id)}> */}
            <div onClick={() => handleLogOut()}>
              <MenuItem onClick={handleClose}>
                <ListItemIcon>
                  <Logout fontSize='small' />
                </ListItemIcon>
                Logout
              </MenuItem>
            </div>
          </Menu>
        </div>
        <IoMdArrowDropdown className={`icon_user1 ${open && "rotate-180"}`} />
      </div>
    </div>
  );
};

export default TopNav;
